import React from 'react';

import SigninForm from './SigninForm';
import SSOSigninSignUpForm from '../sso/SSOSigninSignUpForm';

const SignIn = ({ locales }) => {
  const { onboarding: pageLocales } = locales;

  return (
    <>
      <SigninForm locales={locales} />
      <div className="sign-up-form-section__divider">
        <span className="sign-up-form-section__divider-line" />
        <span className="sign-up-form-section__divider-text">
          {pageLocales.common.or}
        </span>
        <span className="sign-up-form-section__divider-line" />
      </div>
      <SSOSigninSignUpForm locales={pageLocales} />
    </>
  );
};

export default SignIn;
